var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.obj.type === 'exit')?_c('exit',{attrs:{"info":_vm.obj}}):(_vm.obj.type === 'seat')?_c('seat',{attrs:{"info":_vm.obj,"passenger":_vm.obj.passenger,"currentTravelerChoosing":_vm.obj.currentTravelerChoosing,"handleSeatSelection":() => {
        const { handleSeatSelection } = _vm.obj || {};
        if (handleSeatSelection) {
          handleSeatSelection(_vm.obj);
        }
      }}}):(_vm.obj.type === 'facility')?_c('facility',{attrs:{"info":_vm.obj}}):_c('div',{class:(_vm.obj.isExitRow ? 'small-map-block' : 'map-block') + ' empty'},[_c('span',{staticClass:"block-info"},[_vm._v(_vm._s(_vm.obj.row || ""))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }